import useCountUp from '@/hooks/useCountUp';

interface AnimatedStatProps {
  value: number;
  suffix?: string;
  prefix?: string;
  label: string;
  decimals?: number;
  duration?: number;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
}

export default function AnimatedStat({
  value,
  suffix = '',
  prefix = '',
  label,
  decimals = 0,
  duration = 2000,
  className = '',
  valueClassName = '',
  labelClassName = '',
}: AnimatedStatProps) {
  const { displayValue, elementRef } = useCountUp({
    end: value,
    suffix,
    prefix,
    decimals,
    duration,
  });

  return (
    <div ref={elementRef} className={className}>
      <div className={`text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-1 ${valueClassName}`}>
        {displayValue}
      </div>
      {label && (
        <div className={`text-foreground-500 text-sm ${labelClassName}`}>{label}</div>
      )}
    </div>
  );
}